import { render } from "./famousCourseLookVideo.vue?vue&type=template&id=51d1bba4&scoped=true"
import script from "./famousCourseLookVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseLookVideo.vue?vue&type=script&lang=js"

import "./famousCourseLookVideo.vue?vue&type=style&index=0&id=51d1bba4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d1bba4"]])

export default __exports__